import { Injectable } from '@angular/core';
import { IDocumentSearchResult } from '../models/document-search-result';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { IDocumentSearchRequest } from '../models/document-search-request';
import { map, Observable } from 'rxjs';
import { IApiResponse } from '../../../../shared/models/api-response';
import { convertStringDateToJSDate } from '../../../../shared/utilities/date-utility';
import { ISimPublicationMetadata } from '../../../sa-library/shared/models/document-publication-metadata';


@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  baseUrl: string = `${environment.servicesUrl.document}api/document`;

  constructor(
    private http: HttpClient
  ) { }

  public documentSearch(request : IDocumentSearchRequest) : Observable<IApiResponse<IDocumentSearchResult>> {
    const searchResult = this.http.post<IApiResponse<IDocumentSearchResult>>(`${this.baseUrl}/document-search`, request)
    .pipe(
      map((rawResponse) => {
        let response = { ...rawResponse };
        if (rawResponse.success && rawResponse.content) {
          response.content.documents.forEach(d => {
            d.pubDate = convertStringDateToJSDate(d.pubDate as any as string) as any as Date;
          });
        }

        return response;
      })
    );

    return searchResult;
  }

  public canDownloadDocument(documentUri: string): Observable<IApiResponse<boolean>> {
    return this.http.get<IApiResponse<boolean>>(`${this.baseUrl}/can-download-document?documentUri=${documentUri}`);
  }

  public downloadDocument(documentUri: string): Observable<IApiResponse<string>> {
    return this.http.get<IApiResponse<string>>(`${this.baseUrl}/download-document?documentUri=${documentUri}`);
  }

  public getDocumentMetadata(docUri: string): Observable<IApiResponse<ISimPublicationMetadata>> {
    return this.http.get<IApiResponse<ISimPublicationMetadata>>(`${this.baseUrl}/get-metadata-uri/${docUri}`)
  }

   public extractUriFromSearchableUri(searchableUri?: string): string {
      if(searchableUri && searchableUri.length > 0) {
        const xmlName = searchableUri.split('/').pop();
        const uri = xmlName?.split('.').shift();
        return uri ? uri : '';
      }
      return '';
    }
}
